import { render } from "./MultiSelect.vue?vue&type=template&id=2137bb82&ts=true"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./MultiSelect.vue?vue&type=style&index=1&id=2137bb82&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__